<template>
  <div id="orderDriverTabs">
    <el-tabs type="card" v-model="tabAction">
      <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name">
        <template slot="label">
          <i v-if="item.icon" :class="item.icon" style="margin-right: 4px"></i>{{ item.label }}
        </template>
      </el-tab-pane>
    </el-tabs>
    <div class="content" v-show="tabs.length > 0">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "orderDriverTabs",
  data() {
    return {
      // tabs列表
      tabs: [],
      tabAction: null,
    };
  },
  computed: {
    ...mapGetters({ 'permissionsGetter': 'permissionsGetter' })
  },
  watch: {
    tabAction(val) {
      this.$router.push(val);
    },
    $route: {
      handler(val) {
        this.tabAction = val.path;
        if (val.path == '/orderDriver' && this.tabs.length > 0) {
          this.$nextTick(() => {
            this.tabAction = this.tabs[0].name;
          })
        }
      },
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.mixinOrganizations();
    let tabs = [];
    setTimeout(() => {
      if (this.menuPreFn(16)) tabs.push({ label: "专线工单", name: "/orderDriverCustomize", icon: 'el-icon-s-order' });
      if (this.menuPreFn(55)) tabs.push({ label: "班线工单", name: "/orderDriverLine", icon: 'el-icon-tickets' });
      if (this.menuPreFn(89)) tabs.push({ label: "顺风车行程", name: "/orderHitchhikingWork", icon: 'el-icon-position' });
      if (this.menuPreFn(112)) tabs.push({ label: "场站行程", name: "/czOrderDriver", icon: 'el-icon-office-building' });

      this.tabs = tabs;
      this.tabAction = this.tabAction && this.tabAction != '/orderDriver' ? this.tabAction : tabs[0].name;
    }, this.permissionsGetter.length > 0 ? 0 : 1500)
  },
};
</script>

<style lang="less">
#orderDriverTabs {
  height: 100%;

  .content {
    height: calc(100% - 40px);

    &>div {
      height: 100%;
    }
  }
}
</style>
